const MqSettings = {
        breakpoints: {
            mobile: 900,
            laptop: 1250,
            desktop: Infinity
        },
        defaultBreakpoint: 'sm'
    }

export default MqSettings